export default __webpack_public_path__ + "static/media/nipuni.107c6359.png";